import { useV2ListQuestionnaireLookupsForQuestionnaireQuery } from "@generated";
import type { Lookup, LookupTable, LookupValueType } from "../types";

export const useLookupsList = (questionnaireId: string) => {
  const { data, isLoading, isFetching, refetch } =
    useV2ListQuestionnaireLookupsForQuestionnaireQuery(
      {
        questionnaireId: Number(questionnaireId),
        filter: { active: true },
        page: { size: 500 },
      },
      { refetchOnMountOrArgChange: true }
    );

  const rows: Lookup[] = (data?.data ?? []).map((l: any) => ({
    id: String(l.id),
    name: l.attributes?.name ?? "",
    slug: l.attributes?.slug ?? "",
    index1: l.attributes?.["index-1"] ?? "",
    index2: l.attributes?.["index-2"] ?? "",
    valueType: (l.attributes?.["value-type"] ?? "number") as LookupValueType,
    lookups: (l.attributes?.lookups ?? {}) as LookupTable,
  }));

  return { rows, isLoading, isFetching, refetch };
};

export default useLookupsList;
